import React, { useEffect, useState } from 'react';
import { Card, List, Tag, Badge, Empty, Typography } from 'antd';
import { ClockCircleOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getRoutineExecutions } from '../../api/routines';
import { routineColorHex } from '../../constants/routineColors';

const { Text } = Typography;

const statusOf = (item) => {
  if (item.completed_at) return 'completed';
  const scheduled = dayjs(`${item.date} ${item.scheduled_time}`);
  return dayjs().isAfter(scheduled) ? 'overdue' : 'pending';
};

const STATUS_META = {
  completed: ['green', 'Tamamlandı'],
  overdue: ['red', 'Gecikti'],
  pending: ['orange', 'Bekliyor'],
};

const RoutinesTodayPanel = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getRoutineExecutions({ type: 'branch', per_page: 100 }),
      getRoutineExecutions({ type: 'personal', per_page: 100 }),
    ])
      .then(([branchRes, personalRes]) => {
        const merged = [...branchRes.data.data, ...personalRes.data.data]
          .sort((a, b) => a.scheduled_time.localeCompare(b.scheduled_time));
        setItems(merged);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // Rozet "yapilacak is" sayisini gosteriyor - tamamlanmislar disarida.
  const openCount = items.filter((i) => !i.completed_at).length;
  const overdueCount = items.filter((i) => statusOf(i) === 'overdue').length;

  return (
    <Card
      size="small"
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed((c) => !c)}
        >
          {collapsed ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} /> : <DownOutlined style={{ fontSize: 11, color: '#9ca3af' }} />}
          <ClockCircleOutlined style={{ color: '#1677ff' }} />
          Bugünün Rutinleri
          <Badge
            count={openCount}
            style={{ backgroundColor: overdueCount > 0 ? '#ff4d4f' : (openCount > 0 ? '#faad14' : '#d9d9d9') }}
          />
        </span>
      }
      extra={
        <Text
          className="text-xs cursor-pointer"
          type="secondary"
          onClick={() => navigate('/routines')}
        >
          Tümünü Gör
        </Text>
      }
      style={{ marginBottom: 16 }}
    >
      {!collapsed && (
        <List
          size="small"
          loading={loading}
          dataSource={items}
          locale={{ emptyText: <Empty description="Bugün için rutin yok." image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
          renderItem={(item) => {
            const status = statusOf(item);
            const [color, label] = STATUS_META[status];
            const description = item.description || item.routine?.description;
            return (
              <List.Item
                className="cursor-pointer"
                onClick={() => navigate('/routines')}
              >
                <div className="w-full">
                  <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                    <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: routineColorHex(item.color) }} />
                    <span className="text-sm font-medium">{item.name}</span>
                    <Tag style={{ margin: 0 }}>{item.scheduled_time?.slice(0, 5)}</Tag>
                    <Tag color={color} style={{ margin: 0 }}>{label}</Tag>
                    <Tag color={item.routine?.type === 'branch' ? 'blue' : 'default'} style={{ margin: 0 }}>
                      {item.routine?.type === 'branch' ? 'Şube' : 'Kişisel'}
                    </Tag>
                  </div>
                  {description && (
                    <div className="text-xs text-gray-600 mt-0.5" style={{ whiteSpace: 'pre-wrap' }}>
                      {description}
                    </div>
                  )}
                </div>
              </List.Item>
            );
          }}
        />
      )}
    </Card>
  );
};

export default RoutinesTodayPanel;
